import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataAlarme } from '../../data/DataAlarme';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheAlarme } from '../Fiche/FicheAlarme';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        int?        idSouhait                           id du souhait auquel sont rattachées les alarmes
        int?        idContact                           id du contact auquel sont rattachées les alarmes
        bool?       activerFiltres                      détermine s'il faut afficher le bouton filtres
        bool?       activerCreation                     détermine s'il faut afficher le bouton "Créer"
        bool?       afficherAlarmesLieesACapsules       détermine s'il faut afficher les alarmes liées aux espaces
        bool?       afficherAlarmesLieesASouhaits       détermine s'il faut afficher les alarmes liées aux souhaits
        bool?       afficherAlarmesLieesADemandes       détermine s'il faut afficher les alarmes liées aux demandes
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListAlarme extends Component {

    static defaultProps = {
        activerCreation: true,
        activerFiltres: true,
        afficherAlarmesLieesACapsules: false,
        afficherAlarmesLieesASouhaits: false,
        afficherAlarmesLieesADemandes: false,
        afficherAlarmesInactives: true,
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._selection = new Selection({ onSelectionChanged: this._onSelectionChanged });
        this._sortedColumn = "alarmeDateHeure";
        this._objetState = {
            items: [],
            itemActif: {},
            alarmesSelectionnees: [],
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selection={this._selection}
            selectionMode={SelectionMode.multiple}
        />;
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des alarmes en cours..."
        });

        let chargementAlarmes = DataAlarme._chargementAlarmes(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementAlarmes
            .then(responseFetch => {
                const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                let newState = {
                    enCoursDeTraitement: false,
                    messageEnCoursTraitement: '',
                    hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                    warningMessage: retourVerif.warningMessage,
                    hideMessageBarError: retourVerif.hideMessageBarError,
                    errorMessage: retourVerif.errorMessage
                };
                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let listeItem = responseFetch.reponseAPIobjet || [];
                    newState.items = listeItem;
                };
                this.setState(newState);
                this._reinitFiltresTableauDeBord();
            });
    };

    _reinitFiltresTableauDeBord() {
        localStorage.removeItem('filtreDateAlarme');
    }

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState(
            { afficherPanelFiltres: false },
            this._chargementDonnees
        );
    };

    _getCategorie = (item) => {
        const { idSouhait, idContact, idDemande } = item;
        if (idSouhait) return "Souhait";
        if (idContact) return "Capsule";
        if (idDemande) return "Demande";
        return "";
    };

    _getColumns = () => {

        const { afficherAlarmesLieesACapsules, afficherAlarmesLieesASouhaits, afficherAlarmesLieesADemandes } = this.props;
        let columns = [
            {
                key: "contact",
                minWidth: 150,
                maxWidth: 300,
                name: "Contact",
                onRender: (item) => {
                    const contact = item.contact;
                    return <span title={contact}>{contact}</span>;
                }
            },
            {
                key: "alarmeLibelle",
                maxWidth: 300,
                name: "Libellé",
                onRender: (item) => {
                    const alarmeLibelle = item.alarmeLibelle;
                    return <span title={alarmeLibelle}>{alarmeLibelle}</span>;
                }
            },
            {
                key: "nomCommercial",
                minWidth: 150,
                maxWidth: 300,
                name: "Nom commercial",
                onRender: (item) => {
                    const nomCommercial = item.nomCommercial;
                    return <span title={nomCommercial}>{nomCommercial}</span>;
                }
            },
            {
                key: "numero",
                name: "Numéro lot",
                onRender: (item) => {
                    const numero = item.numero;
                    return <span title={numero}>{numero}</span>;
                }
            },
            {
                isSorted: true,
                isSortedDescending: true,
                key: "alarmeDateHeure",
                minWidth: 100,
                maxWidth: 100,
                name: "Date et heure",
                onRender: (item) => {
                    return <span>{Scriba.date().stringDateHeureFormatCourt(item.alarmeDateHeure)}</span>;
                }
            },
            {
                isResizable: true,
                key: "echeance",
                name: "Echéance",
                className: "ms-hiddenLgDown",
                headerClassName: "ms-hiddenLgDown",
                minWidth: 100,
                maxWidth: 100,
                onRender: (item) => {
                    const echeance = Scriba.date().getRelativeTime(item.alarmeDateHeure);
                    return <span title={echeance}>{echeance}</span>;
                }
            },
            {
                key: "alarmeLue",
                minWidth: 50,
                maxWidth: 50,
                name: "Active ?",
                onRender: (item) => {
                    const alarmeLue = item.alarmeLue;
                    return <Toggle
                        ariaLabel="Alarme active"
                        checked={!alarmeLue}
                        onChanged={(checked) => this._toggleDialog(checked ? "activateOne" : "deactivateOne", item)()}
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 20,
                maxWidth: 20,
                name: "Consulter",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanelAlarme(true, item, false)}
                        title="Consulter/modifer l'alarme"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "delete",
                minWidth: 20,
                maxWidth: 20,
                name: "Supprimer",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialog("deleteOne", item)}
                        title="Supprimer l'alarme"
                    />;
                }
            },
        ];

        const onAfficheAuMoinsDeuxCategories = [afficherAlarmesLieesACapsules, afficherAlarmesLieesASouhaits, afficherAlarmesLieesADemandes].filter(Boolean).length >= 2;
        if (onAfficheAuMoinsDeuxCategories)
            columns.unshift({
                key: "categorie",
                minWidth: 75,
                maxWidth: 75,
                name: "Catégorie",
                onRender: (item) => {
                    const categorie = this._getCategorie(item);
                    return <span title={categorie}>{categorie}</span>;
                }
            });

        return columns;

    };

    _getFiltres = () => {
        const { afficherAlarmesLieesASouhaits, afficherAlarmesLieesACapsules, afficherAlarmesLieesADemandes, afficherAlarmesInactives, idOperation, idReservation, idSouhait, idContact, idDemande, fromDate } = this.props;
        let filtres = { afficherAlarmesLieesASouhaits, afficherAlarmesLieesACapsules, afficherAlarmesLieesADemandes, afficherAlarmesInactives };
        if (idSouhait) filtres.idSouhait = idSouhait;
        if (idContact) filtres.idContact = idContact;
        if (idDemande) filtres.idDemande = idDemande;
        if (idOperation) filtres.idOperation = idOperation;
        if (idReservation) filtres.idReservation = idReservation;
        //AF - Filtres utilisés pour les affichages du tableau de bord
        if (localStorage.getItem("filtreDateAlarme") !== null) {
            filtres.fromDate = localStorage.getItem("filtreDateAlarme")
            filtres.afficherAlarmesLieesASouhaits = true;
            filtres.afficherAlarmesLieesACapsules = false;
            filtres.afficherAlarmesLieesADemandes = false;
            filtres.afficherAlarmesInactives = false;
        }
        else if (fromDate) filtres.fromDate = fromDate;
        return filtres;
    };

    _getFarItems = () => {
        let farItems = [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }];
        if (this.props.activerFiltres)
            farItems.push({
                iconOnly: true,
                iconProps: { iconName: "Filter" },
                key: "filtres",
                name: "Filtres",
                onClick: this._togglePanelFiltres(true)
            });
        return farItems;
    };

    _getItems = () => {
        let items = [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            {
                key: "deactivate",
                name: "Désactiver",
                iconProps: { iconName: "RingerRemove" },
                disabled: this._selection.getSelectedCount() <= 0,
                onClick: this._toggleDialog("deactivateMany", this.state.alarmesSelectionnees)
            },
            {
                key: "delete",
                name: "Supprimer",
                iconProps: { iconName: "Delete" },
                disabled: this._selection.getSelectedCount() <= 0,
                onClick: this._toggleDialog("deleteMany", this.state.alarmesSelectionnees)
            }
        ];
        if (this.props.activerCreation) {
            const { idOperation, idReservation, idContact, idSouhait, idDemande } = this.props;
            items.push({
                key: "add",
                name: "Créer une alarme",
                iconProps: { iconName: "Add" },
                onClick: this._togglePanelAlarme(true, { ...FicheAlarme.defaultProps.alarme, idOperation, idReservation, idContact, idSouhait, idDemande }, false)
            });
        }
        return items;
    };

    _modifierStatutAlarme = () => { // Mise à jour d'une alarme
        let alarme = { ...this.state.itemActif };
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: `${alarme.alarmeLue ? "Activation" : "Désactivation"} de l'alarme en cours...`
        });

        alarme.alarmeLue = !alarme.alarmeLue;
        let enregistrementAlarme = DataAlarme._onEnregistrementAlarme(alarme);
        enregistrementAlarme.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                this._chargementDonnees();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
        this._toggleDialog()();
    };

    _desactiverAlarmes = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désactivation des alarmes en cours..."
        });

        const idsAlarmes = this.state.alarmesSelectionnees.map((alarme) => alarme.idAlarme);
        let desactivationAlarmes = DataAlarme._onDesactivationAlarmes(idsAlarmes);
        desactivationAlarmes.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                this._chargementDonnees();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
        this._toggleDialog()();
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _onSelectionChanged = () => {
        this.setState({ alarmesSelectionnees: this._selection.getSelection() });
    };

    _renderDialog = () => {
        const { afficherDialog, nomDialogAffichee } = this.state;
        let dialogProps;
        switch (nomDialogAffichee) {
            case "activateOne": dialogProps = { onClick: this._modifierStatutAlarme, message: "Confirmez-vous l'activation de cette alarme ?", titre: "Activation d'une alarme" }; break;
            case "deactivateOne": dialogProps = { onClick: this._modifierStatutAlarme, message: "Confirmez-vous la désactivation de cette alarme ?", titre: "Désactivation d'une alarme" }; break;
            case "deactivateMany": dialogProps = { onClick: this._desactiverAlarmes, message: "Confirmez-vous la désactivation de ces alarmes ?", titre: "Désactivation d'alarmes" }; break;
            case "deleteOne": dialogProps = { onClick: this._supprimerAlarme, message: "Confirmez-vous la suppression de cette alarme ?", titre: "Suppression d'une alarme" }; break;
            case "deleteMany": dialogProps = { onClick: this._supprimerAlarmes, message: "Confirmez-vous la suppression de ces alarmes ?", titre: "Suppression d'alarmes" }; break;
            default: dialogProps = {}; break;
        };
        return <EUIDialog
            buttons={[
                <PrimaryButton key="confirm" onClick={dialogProps.onClick} text="Confirmer" />,
                <DefaultButton key="cancel" onClick={this._toggleDialog()} text="Annuler" />
            ]}
            isOpen={afficherDialog}
            message={dialogProps.message}
            onDismiss={this._toggleDialog()}
            titre={dialogProps.titre}
        />;
    };

    _supprimerAlarme = () => { // Suppression d'une alarme
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression de l'alarme en cours..."
        });
        let suppressionAlarme = DataAlarme._onSuppressionAlarme(this.state.itemActif.idAlarme);
        suppressionAlarme
            .then(responseFetch => {
                const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
        this._toggleDialog()();
    };

    _supprimerAlarmes = () => { // Suppression de plusieurs alarmes
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression des alarmes en cours..."
        });

        const idsAlarmes = this.state.alarmesSelectionnees.map((alarme) => alarme.idAlarme);
        let suppressionAlarme = DataAlarme._onSuppressionAlarmes(idsAlarmes);
        suppressionAlarme
            .then(responseFetch => {
                const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
        this._toggleDialog()();
    };

    _togglePanelAlarme = (isOpen, item, rechargerLesDonnees) => () => {
        this.setState(
            {
                afficherPanelAlarme: isOpen,
                itemActif: item || {}
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _togglePanelFiltres = (isOpen) => () => {
        this.setState({ afficherPanelFiltres: isOpen });
    };

    _toggleDialog = (nomDialog, item) => () => {
        const afficherDialog = typeof nomDialog !== "undefined";
        let stateTemp = {
            afficherDialog,
            itemActif: item || undefined
        };
        if (afficherDialog) stateTemp.nomDialogAffichee = nomDialog;
        this.setState(stateTemp);
    };

    componentDidMount = () => { this._chargementDonnees(); };

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    render = () => {

        const content = this._creationContent();
        const { itemActif, afficherPanelAlarme, afficherPanelFiltres } = this.state;


        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            {this.props.activerFiltres &&
                <PanelFiltres
                    filtres={{ ...this._filtres }}
                    isOpen={afficherPanelFiltres}
                    onValidation={this._appliquerFiltres}
                    onDismiss={this._togglePanelFiltres(false)}
                />
            }

            <FicheAlarme
                alarme={itemActif}
                isOpen={afficherPanelAlarme}
                onDismiss={this._togglePanelAlarme(false, null, true)}
                onMiseAJour={this._togglePanelAlarme(false, null, true)}
            />

            {this._renderDialog()}

        </Fragment>;

    };

};

export class PanelFiltres extends Component {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            object  filtres                             liste des filtres (clé/valeur)
            bool    isOpen                              détermine si panel ouvert ou non
        METHODES :
            void    onDismiss                           méthode appelée lorsque l'utilisateur clique sur "Annuler"
            void    onValidation(filtres)               méthode appelée lorsque l'utilisateur clique sur "Valider"
    ******************************************************************************************************
    */

    static defaultProps = {
        filtres: {
            afficherAlarmesLieesASouhaits: true,
            afficherAlarmesLieesACapsules: true,
            afficherAlarmesLieesADemandes: true
        }
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _appliquerFiltres = () => {
        const filtres = {
            afficherAlarmesLieesASouhaits: this.state.afficherAlarmesLieesASouhaits,
            afficherAlarmesLieesACapsules: this.state.afficherAlarmesLieesACapsules,
            afficherAlarmesLieesADemandes: this.state.afficherAlarmesLieesADemandes,
        };
        this.props.onValidation(filtres);
    };

    _reinitialiserFiltres = () => {
        this.setState({ ...PanelFiltres.defaultProps.filtres });
    };

    _onOpen = () => {
        this.setState({
            afficherAlarmesLieesASouhaits: this.props.filtres.afficherAlarmesLieesASouhaits,
            afficherAlarmesLieesACapsules: this.props.filtres.afficherAlarmesLieesACapsules,
            afficherAlarmesLieesADemandes: this.props.filtres.afficherAlarmesLieesADemandes,
        });
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._appliquerFiltres}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    render = () => {

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Filtres"
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <Stack>

                <Stack horizontal reversed>
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={this._reinitialiserFiltres}
                    />
                </Stack>

                <Label>Catégories affichées</Label>

                <Checkbox
                    label="Alarmes liées à un espace client" //2378
                    checked={this.state.afficherAlarmesLieesACapsules}
                    onChange={(e, isChecked) => this.setState({ afficherAlarmesLieesACapsules: isChecked })}
                />

                <Checkbox
                    label="Alarmes liées à un souhait"
                    checked={this.state.afficherAlarmesLieesASouhaits}
                    onChange={(e, isChecked) => this.setState({ afficherAlarmesLieesASouhaits: isChecked })}
                />

                <Checkbox
                    label="Alarmes liées à une demande"
                    checked={this.state.afficherAlarmesLieesADemandes}
                    onChange={(e, isChecked) => this.setState({ afficherAlarmesLieesADemandes: isChecked })}
                />

            </Stack>
        </Panel>;

    };

};